"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedDevice = void 0;
const mediasoup_client_1 = require("mediasoup-client");
/**
 * The class accepts `DeviceAPI` and process RTP capabilities
 * before creating a sendTransport or recvTransport.
 */
class ExtendedDevice extends mediasoup_client_1.types.Device {
    constructor(device, opts = {}) {
        super(opts);
        this.device = device;
        /**
         * Represents the current direction of the transport.
         */
        this.directionContext = null;
        this.originalRtpCapabilities = Reflect.get(this, "_extendedRtpCapabilities");
        this.originalCreateTransport = Reflect.get(this, "createTransport");
        // replace _extendedRtpCapabilities with our getter
        Reflect.defineProperty(this, "_extendedRtpCapabilities", {
            get: this.getterRtpCapabilities.bind(this),
            set: this.setterRtpCapabilities.bind(this),
            enumerable: true,
        });
        // override _createTransport with our wrapper
        Reflect.defineProperty(this, "_createTransport", {
            value: this.wrapperCreateTransport.bind(this),
            enumerable: false,
        });
    }
    /**
     * Return the RTP capabilities of the device depending on the direction.
     */
    getterRtpCapabilities() {
        if (this.directionContext == null || this.originalRtpCapabilities == null) {
            return this.originalRtpCapabilities;
        }
        return this.device.processRtpCapabilities(this.directionContext, this.originalRtpCapabilities);
    }
    /**
     * Store the RTP capabilities as is.
     */
    setterRtpCapabilities(val) {
        this.originalRtpCapabilities = val;
    }
    /**
     * Wrapper for the original `createTransport` method.
     * It will process the RTP capabilities before creating the transport.
     */
    wrapperCreateTransport(options) {
        try {
            this.directionContext = options.direction;
            return this.originalCreateTransport(options);
        }
        finally {
            this.directionContext = null;
        }
    }
}
exports.ExtendedDevice = ExtendedDevice;
//# sourceMappingURL=device.js.map